import React from "react";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";

import { Button, colorFirm } from "../../../../../../../../../components/Buttons/Button/Button";
import { Dialog } from "../../../../../../../../../components/dialogs/Dialog/Dialog";

import FormFields from "./FormFields";
import Normalizers from "./Normalizers";

import styles from "./styles.module.scss";

const EditDataSelectorDialog = ({
    initialValues,
    setInitialValues,
    onSubmit,
    onClose,
    isOpen,
    onOpenNormalizerDialog
}) => (
    <Dialog
        title="Edit Data Selector"
        classes={{ paper: styles.dialogPaper }}
        open={isOpen}
        onClose={onClose}
    >
        <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            mutators={{ ...arrayMutators }}
            render={(formProps) => (
                <form
                    className={"form-dialog__form-body"}
                    onSubmit={event => {
                        if(formProps.handleSubmit.then){
                            formProps.handleSubmit(event).then(formProps.form.reset);
                        }else{
                            formProps.handleSubmit(event);
                        }
                    }}
                >
                    <FormFields formProps={formProps} />

                    <Normalizers
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        onOpenNormalizerDialog={onOpenNormalizerDialog}
                    />

                    <div className="form-dialog__controls">
                        <Button
                            className={"form-dialog__controls-btn"}
                            colorFirm={colorFirm.firm2}
                            type={"submit"}
                        >
                                Save
                        </Button>

                        <Button
                            className={"validators-object-structure__btn"}
                            colorFirm={colorFirm.firm3}
                            onClick={onClose}
                        >
                                Close
                        </Button>
                    </div>
                </form>
            )}
        />
    </Dialog>
);

export default EditDataSelectorDialog;
